export default __webpack_public_path__ + "static/media/awaitingTesting.eb2140b9.svg";